import { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

interface TimerComponentProps {
  startTime: Date;
}

const TimerComponent = ({ startTime }: TimerComponentProps) => {
  const [currentTime, setCurrentTime] = useState(startTime);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime((prevTime) => new Date(prevTime.getTime() + 1000));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
        <Typography variant={'h4'} fontWeight="bold">
          {String(currentTime.getUTCHours()).padStart(2, '0')}:
          {String(currentTime.getUTCMinutes()).padStart(2, '0')}:
          {String(currentTime.getUTCSeconds()).padStart(2, '0')}
        </Typography>
      </Box>
    </LocalizationProvider>
  );
};

export default TimerComponent;
